/** @jsx jsx */
import * as React from "react";
import { jsx } from "@emotion/core";
import { get } from "lodash";
import * as styles from '../../../../../../containers/Patient/Transform/WeeklyPlanContainer/style';

import { CustomPopover } from "../../../../../common/CustomPopover/CustomPopover";
import CTA, { CTATheme } from "../../../../../common/CallToAction";
import { IPaginatedMicrocycles, IMicrocycle, IUserFitnessPlan } from "../../../../../../containers/FitnessPlan/FitnessTemplate/interface";
import { RouteUtils } from "../../../../../../routes";
import { STATE_VALUES } from "../../../../../../containers/FitnessPlan/constants";
import { CustomConfirmationModal } from "../../../../../FitnessPlanTemplate/MicrocycleTemplate/CustomConfirmationModal/CustomConfirmationModal";


interface IFitnessPlanAssignmentProps {
    assignFitnessPlan: (selectedPlanId: number) => void;
    fitnessPlansList: IPaginatedMicrocycles;
    assignedFitnessPlan: IMicrocycle | IUserFitnessPlan | any;
    isPastWeek?: boolean;
    transformFactor: string;
    userId: string;
    startDate: number;
    setUserFitnessPlan: (userPlan: any, startDate: string | number, userProfile: any, isPlanPublished: boolean) => void;
    userProfile: any;
    isPublishedFitnessPlan: boolean;
    handlePublishFitnessPlan: (planId: number) => void;
    deleteUserFitnessPlan: (planId: number) => void;
    disablePublish: boolean;
}

export const FitnessPlanAssignment: React.FC<IFitnessPlanAssignmentProps> = (props: IFitnessPlanAssignmentProps) => {
    const { fitnessPlansList, assignFitnessPlan, assignedFitnessPlan, isPastWeek, transformFactor, userId, setUserFitnessPlan, startDate, userProfile, isPublishedFitnessPlan, handlePublishFitnessPlan, deleteUserFitnessPlan, disablePublish } = props;
    const [selectedFitnessPlan, setFitnessPlan] = React.useState(null);
    const [showDeleteModal, setDeleteModalDisplay] = React.useState(false);
    const [showPublishModal, setPublishModalDisplay] = React.useState(false);

    const handleCreatePatientFitnessPlan = () => {
        setUserFitnessPlan(null, startDate, userProfile, isPublishedFitnessPlan);
        RouteUtils.navigateToHrefUrl(null, RouteUtils.getCreateUserFitnessPlanUrl(userId));
    }

    const handleEditPatientPlan = () => {
        setUserFitnessPlan(assignedFitnessPlan, startDate, userProfile, isPublishedFitnessPlan);
        const fitnessPlanId = isPublishedFitnessPlan ? get(assignedFitnessPlan, "microCycleEntry.id", "") : get(assignedFitnessPlan, "id", "");
        RouteUtils.navigateToHrefUrl(null, RouteUtils.getEditUserFitnessPlanUrl(fitnessPlanId, userId));
    }


    const getFooterDesign = () => {
        return (
            <div css={styles.actionsWrapper}>
                <CTA innerText="CREATE NEW" theme={CTATheme.TEXTUAL} onClick={handleCreatePatientFitnessPlan} />
                {fitnessPlansList &&
                    <CTA innerText="ASSIGN" theme={CTATheme.PRIMARY} onClick={() => assignFitnessPlan(selectedFitnessPlan)} customStyle={styles.buttonStyles} />
                }
            </div>
        )
    }

    return (
        <React.Fragment>
            {assignedFitnessPlan ?
                <React.Fragment>
                    <td colSpan={8} css={styles.columnWrapper({ factor: transformFactor })}>
                        {
                            isPublishedFitnessPlan ? <span css={styles.planTitle}><span css={styles.planHeading}>Fitness Plan Published :</span> {assignedFitnessPlan.microCycleEntry.description}</span>
                                :
                                <span css={styles.planTitle}><span css={styles.planHeading}>Fitness Plan Assigned :</span>{assignedFitnessPlan.description} {assignedFitnessPlan.state != STATE_VALUES.LIVE && <span css={styles.draftLabel}>(Draft)</span>}</span>
                        }
                        {
                            !isPastWeek &&
                            <span css={styles.actions}>
                                <CTA innerText="EDIT" theme={CTATheme.TEXTUAL} onClick={handleEditPatientPlan} />
                                {!isPublishedFitnessPlan &&
                                    <React.Fragment>
                                        <CTA disabled={disablePublish} innerText="PUBLISH" theme={CTATheme.PRIMARY} onClick={() => setPublishModalDisplay(true)} customStyle={styles.buttonStyles} />
                                        <img css={styles.deleteIcon} src="/images/delete.svg" alt="delete" onClick={() => setDeleteModalDisplay(true)} />
                                    </React.Fragment>
                                }
                            </span>
                        }
                    </td>

                    {showDeleteModal && <CustomConfirmationModal
                        discardAction={() => setDeleteModalDisplay(false)}
                        confirmAction={() => { deleteUserFitnessPlan(assignedFitnessPlan.id); setDeleteModalDisplay(false) }}
                        modalText={{
                            header: "Confirm Delete?",
                            message: "Do you want to delete the assigned plan?",
                            discard: "Cancel",
                            confirm: "Delete",
                        }}
                        modalSize="xx-small"
                    />}
                    {showPublishModal && <CustomConfirmationModal
                        discardAction={() => setPublishModalDisplay(false)}
                        confirmAction={() => { handlePublishFitnessPlan(assignedFitnessPlan.id); setPublishModalDisplay(false) }}
                        modalText={{
                            header: "Confirm Publish?",
                            message: "Do you want to publish the plan to the user?",
                            discard: "Cancel",
                            confirm: "Publish",
                        }}
                        modalSize="xx-small"
                    />}
                </React.Fragment>
                :
                (<td css={styles.plusIcon({ isPastWeek })}><CustomPopover dropdownOptions={fitnessPlansList && fitnessPlansList.elements.map(plan => ({ displayValue: plan.description, internalValue: plan.id }))}
                    clickLabel={'+'}
                    clickLabelStyles={styles.circle({ isPastWeek })}
                    showTooltipIcon={true}
                    handleOptionSelection={setFitnessPlan}
                    selectedOption={''}
                    showRadioButtonDisplay={true}
                    popoverPlacement='right'
                    showFooterCTA={true}
                    footer={getFooterDesign}
                    customStyles={{ marginTop: 140, padding: 0, paddingBottom: 15 }}
                    showCloseIcon={true}
                />
                </td>)
            }

        </React.Fragment >
    )
}